export default __webpack_public_path__ + "static/media/bg2.637e09a8.svg";